import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import MotionCautionIcon from "../../../../shared/Icons/MotionCautionIcon";
import styles from "./RouteOneSettingsAccordion.module.scss";

export const ROUTE_ONE_URL = "https://www.routeone.net";

const RouteOneSettingsAccordion = () => {
  const { t } = useTranslation();

  return (
    <Box
      className={styles.container}
      data-testid="route-one-settings-accordion"
    >
      <Typography variant="body1" className={styles.copy}>
        {t(
          "DealerOnboarding.content.financing.routeOneSettings.introBeforeRouteOne",
          "Complete the following steps in "
        )}
        <a
          href={ROUTE_ONE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.inlineLink}
        >
          {t(
            "DealerOnboarding.content.financing.routeOneSettings.routeOneText",
            "RouteOne"
          )}
        </a>
        {t(
          "DealerOnboarding.content.financing.routeOneSettings.introAfterRouteOne",
          ":"
        )}
      </Typography>

      <Box component="ol" className={styles.stepsList}>
        <li>
          <strong>
            {t(
              "DealerOnboarding.content.financing.routeOneSettings.customizeRateMarkupLabel",
              "Customize rate markup:"
            )}
          </strong>
          {t(
            "DealerOnboarding.content.financing.routeOneSettings.customizeRateMarkupCopy",
            " Enter a custom rate markup to be displayed with the customer’s approved interest rate (if your dealership does not charge rate markup, 0 can be entered). This rate will only appear to a customer once they have completed their credit application and been approved."
          )}
        </li>

        <li>
          <strong>
            {t(
              "DealerOnboarding.content.financing.routeOneSettings.taxesAndFeesLabel",
              "Taxes & Fees module:"
            )}
          </strong>
          {t(
            "DealerOnboarding.content.financing.routeOneSettings.taxesAndFeesCopy",
            " Designed to provide a quick setup by connecting to Carlton & ATC to provide taxes and state required fees based on your USPS® ZIP+4® Code. In RouteOne, review the sample fees before adding any additional dealer fees."
          )}
        </li>

        <li>
          <strong>
            {t(
              "DealerOnboarding.content.financing.routeOneSettings.uploadPrivacyPolicyLabel",
              "Upload privacy policy in PDF format:"
            )}
          </strong>
          {t(
            "DealerOnboarding.content.financing.routeOneSettings.uploadPrivacyPolicyCopy",
            " This is required to enable Contracting and Remote eSign capabilities, which allows Ford Credit to generate documents inside of RouteOne. Some dealers may already be enrolled and will not need to complete this step."
          )}
        </li>
      </Box>

      <Box className={styles.infoBanner}>
        <span className={styles.infoIcon} aria-hidden="true">
          i
        </span>

        <Typography variant="body2" className={styles.bannerCopy}>
          {t(
            "DealerOnboarding.content.financing.routeOneSettings.infoBannerBeforeAccessRouteOne",
            "Once the ePA has been accepted in RouteOne, all remaining financing setup steps can be completed on the RouteOne site. Select "
          )}
          <strong>
            {t(
              "DealerOnboarding.content.financing.routeOneSettings.accessRouteOne",
              "Access RouteOne"
            )}
          </strong>
          {t(
            "DealerOnboarding.content.financing.routeOneSettings.infoBannerAfterAccessRouteOne",
            " to access your setup details."
          )}
        </Typography>
      </Box>

      <Box className={styles.actionRequiredBanner}>
        <MotionCautionIcon
          sx={{
            color: "#B16201",
            fontSize: 24,
            flex: "0 0 auto",
            marginTop: "-1px",
          }}
        />

        <Typography variant="body2" className={styles.bannerCopy}>
          {t(
            "DealerOnboarding.content.financing.routeOneSettings.actionRequiredBanner",
            "Online Paperwork with eSign is not complete."
          )}
        </Typography>
      </Box>

      <a
        href={ROUTE_ONE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.accessRouteOneButton}
        data-testid="route-one-settings-access-route-one-button"
      >
        <span>
          {t(
            "DealerOnboarding.content.financing.routeOneSettings.accessRouteOne",
            "Access RouteOne"
          )}
        </span>
        <span className={styles.accessRouteOneButtonIcon} aria-hidden="true">
          ›
        </span>
      </a>
    </Box>
  );
};

export default RouteOneSettingsAccordion;
